import { Component } from '@angular/core';
import { LoadingController, NavController, ToastController } from '@ionic/angular';
import { BasePage } from 'src/pages/base.page';
import { ActivatedRoute, Router } from '@angular/router';
import { NavegaTelaPlanoImpl } from 'src/pages/plano-ios/NavegaTelaPlanoImpl';

@Component({
  selector: 'app-recomendacoes-opcoes-boleta',
  templateUrl: './options-billet.page.html',
  styleUrls: ['./options-billet.page.scss'],
})
export class RecomendacoesOpcoesBoletaPage extends BasePage implements NavegaTelaPlanoImpl {


  constructor(
    public router: Router,
    private navCtrl: NavController, 
    public loadingController: LoadingController,
    public toastCtrl: ToastController,
    private activatedRoute: ActivatedRoute,
  ) {
    super(router)
  }

  image

  async ngOnInit() {
    this.image = this.activatedRoute.snapshot.queryParams.image;
  }

  openBack(): void {
    this.navCtrl.pop();
  }
}
